import * as React from 'react';
import { observer } from 'mobx-react';
import { Heading2 } from '@estee/elc-typography';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { classes } from '../../utils/Classes';

export interface IVoiceSearchMessageProps {
    allowPermission: boolean;
    voiceSearchFailure: boolean;
    voiceSearchTerm: string;
    searching: boolean;
    translations?: ITranslationsCollection;
}

const headingAllowMicrophoneClassnames = classes('heading-allow-microphone');
const errorCaptureWrapperClassnames = classes('error-capture-voice-wrapper');
const headingErrorCaptureClassnames = classes('heading-error-capture-voice');
const messageErrorCaptureClassnames = classes('message-error-capture-voice');
const listenMessageClassnames = classes('listen-message-wrapper');
const listenDescriptionClassnames = classes('listen-description');
const listenExampleSearchTermClassnames = classes('listen-example-search-term');
const searchingWrapperClassnames = classes('searching-wrapper');
const voiceSearchTermClassnames = classes('voice-search-term');
const speakNowClassnames = classes('speak-now-message');
@translate([
    'voiceMicrophoneAccess',
    'voiceSearchFailureTitle',
    'voiceSearchFailureParagraph',
    'voiceListenTitle',
    'voiceListenParagraph',
    'voiceListenTermsExample',
    'speakNow',
    'voiceSearchingTitle'
])
@observer
export class VoiceSearchMessage extends React.Component<IVoiceSearchMessageProps> {
    public render() {
        const { allowPermission, voiceSearchFailure, voiceSearchTerm, searching } = this.props;
        const {
            voiceMicrophoneAccess,
            voiceSearchFailureTitle,
            voiceSearchFailureParagraph,
            voiceListenTitle,
            voiceListenParagraph,
            voiceListenTermsExample,
            speakNow,
            voiceSearchingTitle
        } = this.props.translations as ITranslationsCollection;

        return (
            <>
                {allowPermission && (
                    <Heading2 className={headingAllowMicrophoneClassnames}>
                        {voiceMicrophoneAccess}
                    </Heading2>
                )}
                {voiceSearchFailure && (
                    <div className={errorCaptureWrapperClassnames}>
                        <Heading2 className={headingErrorCaptureClassnames}>
                            {voiceSearchFailureTitle}
                        </Heading2>
                        <p className={messageErrorCaptureClassnames}>
                            {voiceSearchFailureParagraph}
                        </p>
                    </div>
                )}
                {searching && (
                    <div className={searchingWrapperClassnames}>
                        <Heading2>{voiceSearchingTitle}</Heading2>
                        <p className={voiceSearchTermClassnames}>"{voiceSearchTerm}"</p>
                    </div>
                )}
                {!voiceSearchFailure && !allowPermission && !searching && (
                    <div className={listenMessageClassnames}>
                        <Heading2>{voiceListenTitle}</Heading2>
                        <p className={listenDescriptionClassnames}>{voiceListenParagraph}</p>
                        <p className={listenExampleSearchTermClassnames}>
                            {voiceListenTermsExample}
                        </p>
                        <p className={speakNowClassnames}>{speakNow}</p>
                    </div>
                )}
            </>
        );
    }
}
